export const environment = {
    production: false,
    apiBaseURL: 'https://qa-campaign-page-data-api.lrsphub.com',
    ipURL:"https://api.ipify.org/?format=json",
    zipLookupURL: "https://lps.submitsecurity.com/webservice/zipLookupAPI-simple.php?zip="
}